import { AcknowledgementName } from "@wingspanhq/wingspan-api-sdk";
import { WSMutationConfig } from "@ws-react-query";
import { queriesAcknowledgements } from "@query";
import { useWSMutation } from "../../../../query/helpers";
import { useUserId } from "../../../../query/hooks/helpers";
import { QUERY_USERS_ACTIVITIES } from "../../../../query/users/keys";
import { usersService } from "../../../../services/users";
import { acknowledgementVersions } from "../../../../shared/constants/acknowledgements";
import { WSServiceError } from "../../../../utils/serviceHelper";

export const useMutationSubmit = (config?: WSMutationConfig<void>) => {
  const userId = useUserId();
  const [acceptAcknowledgement] =
    queriesAcknowledgements.acceptAcknowledgement.useMutation();

  return useWSMutation<any, WSServiceError>(
    async () => {
      await usersService.activity.update(userId, {
        events: {
          w8BenFormAcknowledged: new Date()
        }
      });

      await acceptAcknowledgement({
        acknowledgementName: AcknowledgementName.W8_BEN_CERTIFICATION,
        acceptAcknowledgementRequest: {
          version:
            acknowledgementVersions[AcknowledgementName.W8_BEN_CERTIFICATION]
        }
      });
    },
    {
      dependencies: [QUERY_USERS_ACTIVITIES],
      ...config
    }
  );
};
